<template>
  <div class="editable-text-area editing-cell" v-if="isEditing">
    <vs-textarea v-model="input" :disabled="disabled">
    </vs-textarea>
  </div>
  <div v-else class="editable-text-area">
    <span class="display-text">{{string}}</span>
  </div>
</template>

<script>

export default {
  props: {
    string: { type: String },
    isEditing: { type: Boolean },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      input: this.string
    }
  },
  watch: {
    input(value) {
      this.$emit("updateValue", value)
    },
    isEditing() {
      this.input = this.string
    }
  },
}
</script>

<style lang="scss">
.editing-cell {
  padding-left: 0px !important;
  padding-right: 0px !important;
  .vs-textarea-primary {
    background: white;
  }
  .vs-con-textarea {
    margin: 0px;
  }
}
.editable-text-area {
  word-break: break-all;
  flex-grow: 1;
  .display-text {
    word-break: break-all;
  }
} 
</style>
